






import { listFactory } from '@/main/pages';
import { PageMode } from '@/main/utils/pageMode';
import { openEdit } from '@/main/router/routerPath';

import { store } from './store/list';
import { NAME } from './constants';

export default listFactory(NAME, store).extend({
	methods: {
		editClick(event: any) {
			openEdit(NAME, PageMode.EDIT, { id: event.data.ID });
		},
	},
});
